import { useParams } from "react-router";
import { Card } from "@/shared/components/ui/card";
import { CalculationListTable } from "@/routes/processes/[processId]/qpm/calculations/_components/calculation-list-table";
import {
  MilestonePage,
  MilestonePageActions,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import t from "@/lang/lang";
import { CreateCalculationDialog } from "@/routes/processes/[processId]/qpm/calculations/_components/create-calculation-dialog";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { Loader2 } from "lucide-react";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

export function CalculationIndexRoute() {
  const params = useParams();
  const { processId } = params;

  const {
    data: process,
    error: processDataError,
    isLoading: processDataIsLoading,
  } = useProcessesProcessShowQuery({
    id: processId ?? "",
  });

  if (processDataIsLoading) {
    return <Loader2 className="animate-spin" />;
  }

  if (!processId || !process) {
    return <div>Fehler beim Laden des Vorgangs!</div>;
  }

  if (processDataError) {
    return <RTKQueryErrorAlert error={processDataError} />;
  }

  return (
    <MilestonePage>
      <MilestonePageHeader>
        <MilestonePageTitle>{t("Kalkuklationen")}</MilestonePageTitle>
        <MilestonePageActions>
          <CreateCalculationDialog
            customerId={process.customerId!}
            processId={processId!}
          />
        </MilestonePageActions>
      </MilestonePageHeader>
      <MilestonePageContent>
        <Card>
          <CalculationListTable processId={processId!} />
        </Card>
      </MilestonePageContent>
    </MilestonePage>
  );
}
